<template>
   <div style="background: white; border-radius: 4px">
     <select
         :id="name"
         :value="displayValue"
         class="custom-select form-control"
         :class="{ 'form-control-danger': errors, [className]: className }"
         @input="event => this.$emit('input', event.target.value)"
         :disabled="disabled"
         :style="!displayValue ? 'color: #c2c2c2': 'color: black'"
     >
       <option v-if="placeholder" value="" class="text-muted">{{ placeholder }}</option>
       <option
           style="color: #1e1e1e"
           v-for="option in options"
           :value="get(option, valueField)"
           :key="get(option, valueField)"
       >
         {{ get(option, textField) }}
       </option>
     </select>
   </div>
</template>

<script>

export default {
  name: "DSelectInput",
  props: {
    name: String,
    value: [String, Number],
    label: String,
    valueField: {
      type: String,
      default: 'value'
    },
    textField: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    required: Boolean,
    options: Array,
    errors: Array,
    className: [String, Array, Object],
    inline: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    displayValue() {
      return this.value || "";
    }
  }
};
</script>